module.exports = __webpack_public_path__ + "img/c.56e0383f.jpg";